const variables = {
  iconSize: 24,
};

export default variables;
